
import React from 'react';
import { motion } from 'framer-motion';

interface StreamingIndicatorProps {
  isStreaming: boolean;
}

export const StreamingIndicator: React.FC<StreamingIndicatorProps> = React.memo(({ 
  isStreaming 
}) => {
  const streamingIndicatorAnimation = {
    opacity: [0.6, 1, 0.6],
    transition: { 
      duration: 1.5, 
      repeat: Infinity, 
      ease: "easeInOut" 
    }
  };

  if (!isStreaming) return null;

  return (
    <motion.span 
      className="ml-2 text-xs font-normal text-blue-400"
      animate={streamingIndicatorAnimation}
    >
      streaming...
    </motion.span>
  );
});

StreamingIndicator.displayName = "StreamingIndicator";
